import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type {
  StructsBulkTagSimsResponse,
  StructsTagSimsRequest,
} from 'types/__generated__/SimInventoryApi';

interface UseBulkTagCallProps {
  action?: 'link' | 'unlink';
  organizationId?: OrgId;
}

type ReturnVal = Promise<StructsBulkTagSimsResponse | undefined>;

const useBulkTagCall = ({ action, organizationId }: UseBulkTagCallProps) => {
  const url = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/tag`;

  const callback = useCallback(
    async (hologramSimIds?: Array<HologramSimId>, tagIds?: Array<TagId>): ReturnVal => {
      const postBody: StructsTagSimsRequest = {
        action,
        organizationId,
        hologramSimIds,
        tagIds,
      };

      const result: StructsBulkTagSimsResponse | undefined = await postFetcher({
        url,
        body: postBody,
      });

      return result;
    },
    [action, organizationId, url]
  );

  return callback;
};

export default useBulkTagCall;
